import React from "react";
import { useSelector } from "react-redux";
import {  RootState } from "../../store";
import {
    FaFacebookF,
    FaInstagram,
    FaTwitter,
    FaWhatsapp,
} from "react-icons/fa"; 
import { AiFillHome } from 'react-icons/ai';
import { useTranslation } from "react-i18next";
import { useSEO } from "../../custom hooks/useSEO";

const AboutSite = () => {
    const { t, i18n} = useTranslation();
    const { siteInfo } = useSelector((state: RootState) => state.settingSlice);

    const seo = useSEO({
        title: `${siteInfo?.siteName} | ${t('about_us')}`,
        description: "مرحبا بك في الموقع الرسمي الخاص بنا.",
        keywords: "LiBooking ,travel ,hotel,about us ",
        image: `${siteInfo?.darkLogo}`,
        url: "https://liBooking.com/about",
    });
    return (
        <div>
            <div className=' green-hero flex-center  relative main-prop xs:h-full md:h-[70vh] padding-container'>
                {seo}
                <div>
                    <div className="relative z-20 text-white text-center py-10">
                        <h1 className="text-4xl font-bold mb-2">{t('about_us')}</h1>
                        <div className="flex items-center justify-center gap-1 text-base">
                            <AiFillHome className="mr-1 text-white text-lg" />
                            <span>{t('home')}</span>
                            <span className="mx-2">/</span>
                            <span>{t('about_us')}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" padding-container main-prop leading-7">
                <h1 className="text-primary text-3xl font-bold mb-10">
                    <span className=" text-black">{t("about")}: </span>
                    <span >{i18n.language==="en"? siteInfo?.siteName: siteInfo?.siteNameAr}</span>
                </h1>

                <div className="  text-sm md:text-base">
                    <div className="relative">
                        <div className="p-4">
                            <img
                                src="/asset/bubai-trip.jpg"
                                alt="About"
                                className="sm:w-96 xs:w-full h-auto xs:float-none sm:float-left  rounded-xl shadow-xl"
                            />
                        </div>

                        <p className=" text-textSecond">
                            {i18n.language==="en"? siteInfo?.siteDescription: siteInfo?.siteDescriptionAr}
                        </p>
                    </div>
                </div>

                {/* معلومات التواصل */}
                <div className="flex my-5 gap-3">

                    {siteInfo?.whatsapp && (<ContactItem icon={<FaWhatsapp />} text={siteInfo.whatsapp} />)}
                    {siteInfo?.facebook && (<ContactItem icon={<FaFacebookF />} text={siteInfo.facebook} />)}
                    {siteInfo?.instagram && (<ContactItem icon={<FaInstagram />} text={siteInfo.instagram} />)}
                    {siteInfo?.twitter && (<ContactItem icon={<FaTwitter />} text={siteInfo.twitter} />)}
                </div>
            </div>
        </div>



    );
};

const ContactItem = ({ icon, text }: { icon: React.ReactNode; text: string }) => (
    <a href={text} target="_blank" rel="noopener noreferrer" className="flex-center gap-2 w-10 h-10 bg-black rounded-full">
        <span className="text-white text-lg">{icon}</span>
    </a>
);

export default AboutSite;
